import React, { createContext, useContext, useEffect, useState } from "react";
import { api, fmtErr } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("rt_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("rt_token"))
      .finally(() => setLoading(false));
  }, []);

  const persist = (data) => {
    localStorage.setItem("rt_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    try { const r = await api.post("/auth/login", { email, password }); return persist(r.data); }
    catch (e) { throw new Error(fmtErr(e.response?.data?.detail) || "Login failed"); }
  };
  const register = async (payload) => {
    try { const r = await api.post("/auth/register", payload); return persist(r.data); }
    catch (e) { throw new Error(fmtErr(e.response?.data?.detail) || "Register failed"); }
  };
  const loginGoogle = async (session_id) => {
    try { const r = await api.post("/auth/google", { session_id }); return persist(r.data); }
    catch (e) { throw new Error(fmtErr(e.response?.data?.detail) || "Google login failed"); }
  };
  const logout = () => { localStorage.removeItem("rt_token"); setUser(null); };
  const refresh = async () => { const r = await api.get("/auth/me"); setUser(r.data); return r.data; };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, loginGoogle, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
